import { authWrapper } from "@/services/auth";
import { dateChecker } from "@/services/dateChecker";

export const apiWrapper = async (
  method,
  apiName,
  params,
  isNotReCall = false,
  dbsSessionId = null, // DBSのログイン必須APIでのみ使用
  endPoint,
  timeout
) => {
  try {
    const resp = await authWrapper(
      method,
      apiName,
      params,
      isNotReCall,
      dbsSessionId,
      endPoint,
      timeout
    );
    if (process.env.VUE_APP_ENV === "production") {
      dateChecker(resp.headers.date);
    }
    return resp;
  } catch (err) {
    throw err;
  }
};
